export default "__VITE_ASSET__Bbbmneaz__"